import { Direction } from '@angular/cdk/bidi';
import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Observable, Subscription, tap } from 'rxjs';
import { SelectOption } from 'src/app/@shared/interfaces/select-option.interface';
import { LanguageService } from 'src/app/@shared/services/language/language.service';
import { TARIFF_PROFILE_LABEL } from 'src/app/modules/route-planner/constants/multi-language.constants';
import { TariffProfile } from 'src/app/modules/route-planner/interfaces/route-planning/gtfs/tariff-profile.interface';
import { ScheduleService } from 'src/app/modules/route-planner/services/schedule/schedule.service';

const DEFUALT_PROFILE_ID = 1;


@Component({
    selector: 'app-tariff-profile-selector',
    templateUrl: './tariff-profile-selector.component.html',
    styleUrls: ['./tariff-profile-selector.component.scss'],
    standalone: false
})
export class TariffProfileSelectorComponent implements OnInit, OnDestroy {
  @Output() onToggleChange = new EventEmitter<boolean>();

  @Input() priceProfileFormControl: FormControl<TariffProfile>;
  @Input() priceCalculationLabel: string;
  @Input() class: string;
  @Input() showRoutePrice: boolean;

  /**
   * a11y: accessible name for the tariff <mot-select> combobox. The select
   * itself has no visible label by design (the trigger just shows the chosen
   * profile e.g. "Regular"), so we provide an aria-label so screen readers
   * announce the combobox's purpose.
   */
  tariffProfileLabel: string = '';

  private languageSubscription: Subscription;

  tariffProfiles: Observable<SelectOption<TariffProfile>[]> =
    this.scheduleService.getTariffProfiles().pipe(
      tap((profiles) => {
        if (!!profiles && profiles.length) {
          const defaultProfile = profiles.find(
            (profile) => profile.value.id == DEFUALT_PROFILE_ID
          );

          this.priceProfileFormControl.setValue(defaultProfile?.value);
        }
      })
    );

  constructor(
    private readonly scheduleService: ScheduleService,
    private readonly languageService: LanguageService,
  ) {
  }

  ngOnInit(): void {
    this.languageSubscription = this.languageService.selectedLanguage$.subscribe(
      (language) => {
        if (!language) return;
        const key = language.language as 'hebrew' | 'english' | 'arabic';
        this.tariffProfileLabel = TARIFF_PROFILE_LABEL[key];
      }
    );
  }

  ngOnDestroy(): void {
    this.languageSubscription?.unsubscribe();
  }
}
